import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["form", "submitBtn", "option"]
  static values = { surveyId: Number }

  connect() {
    this.showModal()
  }

  showModal() {
    $(this.element).modal('show')
  }

  hideModal() {
    $(this.element).modal('hide')
  }

  optionSelected() {
    const selected = this.formTarget.querySelector('input[name="survey_option_id"]:checked')
    this.submitBtnTarget.disabled = !selected
  }

  submit() {
    const selected = this.formTarget.querySelector('input[name="survey_option_id"]:checked')
    if (!selected) return

    this.submitResponse(selected.value, false)
  }

  submitNoOpinion() {
    this.submitResponse(null, true)
  }

  submitResponse(optionId, noOpinion) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

    fetch('/survey_responses', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify({
        survey_id: this.surveyIdValue,
        survey_option_id: optionId,
        no_opinion: noOpinion
      })
    })
    .then(response => {
      if (response.ok) {
        this.hideModal()
      }
    })
    .catch(error => {
      console.error('Survey submission error:', error)
    })
  }
}
